export default __webpack_public_path__ + "static/media/assistant11.acdb1a3f.jpeg";